import { useAtom, useAtomValue } from 'jotai';
import getConfig from 'next/config';
import { Box } from 'components/primitives/box';
import Counter from 'components/ui/Counter/Counter';
import useRudderStackTrack from 'hooks/useRudderStackTrack';
import { useEffect, useRef } from 'react';
import { passengersCountAtom, passengersFilterActiveAtom } from '../filterStore';

const { COVID_LIMIT_ENABLED } = getConfig().publicRuntimeConfig;

export default function PassengersFilterContent(props) {
  const [passengers, setPassengers] = useAtom(passengersCountAtom);
  const timeoutRef = useRef(null);
  const rudderTrack = useRudderStackTrack();
  useEffect(() => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    timeoutRef.current = setTimeout(() => {
      rudderTrack('passengers_change_search', {
        value: passengers,
      });
    }, 2000);
  }, [passengers]);

  return (
    <Box {...props} data-testid="search-filter-passengers-box">
      <Counter
        boatCapacity={COVID_LIMIT_ENABLED ? 10 : 14}
        minimum={1}
        value={passengers}
        // buttonSize={40}
        onClick={setPassengers}
      />
    </Box>
  );
}

export const PassengersLabel = () => {
  const passengers = useAtomValue(passengersCountAtom);
  const filterActive = useAtomValue(passengersFilterActiveAtom);
  if (!filterActive) return <span>Passengers</span>;
  return <span>{`${passengers}${passengers === 14 ? '+' : ''} ${passengers === 1 ? 'Passenger' : 'Passengers'}`}</span>;
};
